import { render, staticRenderFns } from "./GrantsResource.vue?vue&type=template&id=32af3438&scoped=true&"
import script from "./GrantsResource.vue?vue&type=script&lang=js&"
export * from "./GrantsResource.vue?vue&type=script&lang=js&"
import style0 from "./GrantsResource.vue?vue&type=style&index=0&id=32af3438&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32af3438",
  null
  
)

export default component.exports